import { t } from '@lingui/macro'
import { Text } from '@lune-fe/lune-ui-lib'
import ArrowDownwardOutlinedIcon from '@mui/icons-material/ArrowDownwardOutlined'
import ArrowUpwardOutlinedIcon from '@mui/icons-material/ArrowUpwardOutlined'
import Box from '@mui/material/Box'
import type { FC, ReactNode } from 'react'

const getTrendIndicator = (trendIndicator: number): ReactNode => {
    if (trendIndicator > 0) {
        return (
            <>
                <ArrowUpwardOutlinedIcon /> {trendIndicator}%
            </>
        )
    }

    if (trendIndicator < 0) {
        return (
            <>
                <ArrowDownwardOutlinedIcon /> {Math.abs(trendIndicator)}%
            </>
        )
    }

    return '0%'
}

const getIndicatorStyles = (
    trendIndicator: number,
    colorIndicator: boolean,
): { backgroundColor: string; color: string } => {
    if (!colorIndicator) {
        return {
            backgroundColor: 'Surface300',
            color: 'TextSecondary',
        }
    }

    if (trendIndicator > 0) {
        return {
            backgroundColor: 'SurfaceInfoGreen100',
            color: 'TextInfoGreen',
        }
    }

    if (trendIndicator < 0) {
        return {
            backgroundColor: 'SurfaceDestructive100',
            color: 'TextDestructive',
        }
    }

    return {
        backgroundColor: 'Surface300',
        color: 'TextSecondary',
    }
}

const TrendIndicator: FC<{ trendIndicator: number; colorIndicator?: boolean }> = ({
    trendIndicator,
    colorIndicator = false,
}) => {
    const indicatorStyles = getIndicatorStyles(trendIndicator, colorIndicator)

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                mt: 1,
            }}
        >
            <Text
                variant={'caption'}
                sx={{
                    borderRadius: '20px',
                    px: 1 / 2,
                    py: 1 / 4,
                    ...indicatorStyles,
                    svg: {
                        height: '12px',
                        width: '12px',
                        flex: '1 0 auto',
                    },
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1 / 4,
                }}
            >
                {getTrendIndicator(trendIndicator)}
            </Text>
            <Text variant={'caption'} sx={{ color: 'TextSecondary' }}>
                {t`vs previous period`}
            </Text>
        </Box>
    )
}

export default TrendIndicator
